<template>
    <div class="train-select">
        <div class="train-select__card">
            <icon-button class="train-select__close" @click="closeInfo">close</icon-button>

            <form class="train-select__form">
                <ul class="train-select__list">
                    <li v-for="item in trainList"
                        :key="item.id"
                        class="train-select__item"
                        :class="{
                            'train-select__item--selected': item.selected
                        }"
                        v-show="!item.hidden"
                        :id="'Train'+item.id"
                        @click.prevent="item.selected = !item.selected"
                    >
                        {{item.train}}
                    </li>
                </ul>

                <div class="train-select__bottom">
                    <input class="train-select__input" type="text" placeholder="Suche" v-model="trainsearch">

                    <div class="train-select__buttons">
                        <default-button class="train-select__submit" @click.prevent="submitTrains">
                            Auswählen
                        </default-button>

                        <default-button class="train-select__reset"
                                        :variations="['danger']"
                                        @click.prevent="delSelected"
                        >
                            Zurücksetzen
                        </default-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import DefaultButton from '../common/default-button.vue';
import IconButton from '../common/icon-button.vue';

export default {
    components: {
        DefaultButton,
        IconButton
    },
    data() {
        return {
            trainSelection: [],
            trainsearch: ''
        }
    },
    computed: {
        trainList() {
            return this.$store.getters['fotodatenbank/trains'];
        },
        selectedTrains() {
            return this.$store.getters['fotodatenbank/selectedTrains'];
        }
    },
    methods: {
        closeInfo() {
            this.$router.go(-1);
        },
        submitTrains() {
            for (let i = 0; i < this.trainList.length; i++) {
                if (this.trainList[i].selected) {
                    this.trainSelection.push({ id: this.trainList[i].id, train: this.trainList[i].train });
                }
            }

            this.$store.dispatch('fotodatenbank/selectedTrains', this.trainSelection);
        },

        delSelected() {
            // turn the background color of the selected ones to none
            // del the local selected variable
            for (let i = 0; i < this.trainList.length; i++) {
                this.trainList[i].selected = false;
            }
            this.trainSelection = [];
        }

    },
    watch: {
        trainsearch: function() {
            if (this.trainsearch.length >= 2) {
                for (let i = 0; i < this.trainList.length; i++) {
                    if (!this.trainList[i].train.toUpperCase().includes(this.trainsearch.toUpperCase())) {
                        this.trainList[i].hidden = true;
                    } else {
                        this.trainList[i].hidden = false;
                    }
                }
            } else {
                for (let i = 0; i < this.trainList.length; i++) {
                    this.trainList[i].hidden = false;
                }
            }
        }
    },
    created() {
        this.$store.dispatch('fotodatenbank/getAllTrainsWithFav');
    }
}
</script>

<style scoped lang="scss">
    .train-select__close {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }

    .train-select {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .train-select__card {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        background-color: $color-white;
        @include default-shadow;
        padding-top: 4.5rem;
        padding-bottom: 1rem;
    }

    .train-select__form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }

    .train-select__list {
        overflow-x: auto;
        width: 100%;
        flex-grow: 1;
    }

    .train-select__item {
        width: 100%;
        font-size: 2rem;
        cursor: pointer;
        padding-left: 1rem;
        transition: background-color ease-out .1s;

        &:hover {
            background-color: $color-list-hover;
        }

        &:active,
        &--selected {
            color: $color-white;
            background-color: $color-action;

            &:hover {
                background-color: $color-action;
            }
        }
    }

    .train-select__bottom {
        padding-top: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .train-select__input {
        font-size: 1.5rem;
        width: 100%;
    }

    .train-select__buttons {
        display: flex;
        flex-direction: row;
        padding-top: 1rem;
    }

    .train-select__submit {
        flex-grow: 1;
        margin-right: 1rem;
    }

    .train-select__reset {

    }

    @include medium {
        .train-select__card {
            width: 31rem;
        }

    }

    @include extra-large {
        .train-select__card {
            width: 600px;
            height: 80vh;
        }
    }

</style>
